// The curvature-at-junction view of a CaJ relation: the value and meta_full_curvature
// as a profile; the members are in the entry's members table. The derived rows (NDS
// curvature, radius, max speed) come from layers/style/curvature.js in the glue.
import { baseKey } from "./lrValues.mjs";

const ARC_TYPES = new Set(["curvature-arc", "curvature-arc-dummy"]);

/**
 * @param {Record<string, unknown>} properties of a feature the CaJ arc handler made
 * @returns {string|undefined} the id of the relation the arc was drawn from
 */
export function relationIdForArc(properties) {
  if (!ARC_TYPES.has(properties?.type)) return undefined;
  const id = properties["relation-id"];
  return id === undefined || id === null ? undefined : String(id);
}

/**
 * @param {import("./featureModel.mjs").FeatureModel} model
 */
export function buildCajView(model) {
  const tags = model.groups.flatMap((g) => g.tags);
  const value = tags.find((t) => baseKey(t.key) === "curvature_at_junction");
  if (!value) return null;
  // Only a chain the profile can draw is the view's; else it stays in its group.
  const full = tags.find(
    (t) =>
      baseKey(t.key) === "meta_full_curvature" &&
      t.sections &&
      t.lr === "linear",
  );
  return {
    value: String(value.value),
    fullCurvature: full ? full.sections : null,
    usedTags: full ? [value, full] : [value],
  };
}
